import {
    Box,
    Typography,
    Grid,
    useMediaQuery,
    useTheme,
    Container,
  } from "@mui/material";
  import colors from "colors/color";
  import React, { useEffect, useState } from "react";
  import { useLocation, useNavigate } from "react-router-dom";
  import { useTranslation } from "react-i18next";
  import CustomPagination from "views/client/pagination";
  import SpontaneousCard from "./SpontaneousCard";
  
  
  function ListSpontaneous({ 
    setSelectedSpontaneous, 
    setOpenDialog,
    spontaneousList,
    loading,
    error,
    pagination,
    goToNextPage,
    goToPreviousPage,
    goToPage,
    refreshSpontaneous,
  }) {
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const { t } = useTranslation();
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiUrlsoket = process.env.REACT_APP_API_URL_SOKET;
  
    const [ChatComponent, setChatComponent] = useState(false);
    const [allSpontaneous, setAllSpontaneous] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [isAuth, setIsAuth] = useState(false);
    const [openLoginDialog, setOpenLoginDialog] = useState(false);
    const [openSignInDialog, setOpenSignInDialog] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [noResultsMessage, setNoResultsMessage] = useState("");
    const [isFooterVisible, setIsFooterVisible] = useState(false);
    const [lastSpontaneous, setLastSpontaneous] = useState(null);
    const [firstSpontaneous, setFirstSpontaneous] = useState(null);
    const [isShrinked, setIsShrinked] = useState(false);
    const isSmallScreen = useMediaQuery("(max-width: 892px)");
    const navigate = useNavigate();
    
    const [incomingSpontaneous, setIncomingSpontaneous] = useState(null);
    const breakpoints = {
      sm: '(min-width: 640px)',
      md: '(min-width: 1304px)',
      lg: '(min-width: 1688px)',
    };
    
    
    const handleChangePage = (event, newPage) => {
      goToPage(newPage + 1); 
  
      window.scrollTo({
        top: 500,
        behavior: "smooth",
      });
    };
    
    useEffect(() => {
      console.log(
        "spontaneousList data:", 
        {
          length: spontaneousList?.length || 0,
          hasData: Array.isArray(spontaneousList) && spontaneousList.length > 0,
          example: spontaneousList?.length > 0 ? JSON.stringify(spontaneousList[0]) : 'No data'
        }
      );
    }, [spontaneousList]);
  
    const Load = async (pageNumber = 1) => {
      setIsLoading(true);
  
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const accessToken = localStorage.getItem("accessToken");
        let response;
  
        if (accessToken) {
          console.log("token::", accessToken);
          response = await fetch(`${apiUrl}authentication/all-application-forms/?page=${pageNumber}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          });
        } else {
          response = await fetch(`${apiUrl}authentication/all-application-forms/?page=${pageNumber}`);
        }
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
  
        const json = await response.json();
  
        setAllSpontaneous(json.results);
        setLastSpontaneous(json.results[0]);
        setHasMore(!!json.next);
        setTotalCount(json.count || 0);
  
        if (pageNumber > 1) {
          setSelectedSpontaneous(json.results[0]);
        } else {
          setSelectedSpontaneous((prev) => prev || json.results[0]);
        }
  
        const cardContainer = document.querySelector(".mycard-scroll");
        if (cardContainer) {
          cardContainer.scrollTop = 0;
        }
      } catch (error) {
        console.error("Error fetching spontaneous applications:", error);
      } finally {
        setIsLoading(false);
      }
    };
  
    const [rowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const handlePageChange = (event, newPage) => {
      setPage(newPage + 1);
      Load(newPage + 1);
  
      window.scrollTo({
        top: 500,
        behavior: "smooth",
      });
  
      const cardContainer = document.querySelector(".mycard-scroll");
      if (cardContainer) {
        cardContainer.scrollTo({
          top: 500,
          behavior: "smooth",
        });
      }
    };
  
    useEffect(() => {
      Load(1);
    }, []);
  
    useEffect(() => {
      if (page > 1) {
        Load(page);
      }
    }, [page]);
  
    const handleSearchResults = (results, message) => {
      setSearchResults(results);
      setNoResultsMessage(message);
      setPage(1);
      if (results.length > 0) {
        setSelectedSpontaneous(results[0]);
      }
    };
    
    return (
      <Container maxWidth="xxl">
        <Box
          sx={{
            marginTop: { xs: 2, sm: 3, md: 4 },
            padding: { xs: 0, sm: 2, md: 0 },
          }}
        >
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: { xs: "28px", sm: "34px", md: "40px" },
              lineHeight: { xs: "42px", sm: "50px", md: "60px" },
              letterSpacing: "0%",
              color: colors.primary,
              display: "flex",
              flexDirection: "row",
              alignItems: { xs: "flex-start", sm: "center" },
            }}
          >
            {totalCount}
            <Box
              sx={{
                color: "#000",
                ml: { xs: 0, sm: 1 },
                fontWeight: 400,
              }}
            >
              {t("spontaneous.positions_found")}
            </Box>
          </Typography>
          <Grid
            container
            spacing={{ xs: 2, sm: 2, md: 3, lg: 3 }}
            sx={{ marginTop: { xs: 2, sm: 3, md: 4 } }}
          >
            {Array.isArray(spontaneousList) && spontaneousList.length > 0 ? (
              spontaneousList.map((spontaneous) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  xl={3}
                  key={spontaneous.id || Math.random()}
                >
                  <SpontaneousCard
                    spontaneous={spontaneous}
                    setSelectedSpontaneous={setSelectedSpontaneous}
                    setOpenDialog={setOpenDialog}
                  />
                </Grid>
              ))
            ) : (
              <Grid item xs={12}>
                <Box sx={{ textAlign: "center", py: 4 }}>
                  <Typography variant="body1">
                    {t("spontaneous.no_applications_found")}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
          {pagination &&
            pagination.totalPages > 0 &&
            spontaneousList.length > 0 && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                  mt: 3,
                  mb: 3,
                }}
              >
                {loading ? (
                  ""
                ) : (
                  <CustomPagination
                    page={pagination.currentPage - 1}
                    rowsPerPage={10}
                    count={pagination.totalPages * 10}
                    handleChangePage={handleChangePage}
                  />
                )}
              </Box>
            )}
        </Box>
      </Container>
    );
  }
  
  export default ListSpontaneous;
  